import { createI18n } from 'vue-i18n';
import messages from '@intlify/unplugin-vue-i18n/messages'; // https://github.com/intlify/bundle-tools/tree/main/packages/unplugin-vue-i18n
import type { App } from 'vue';
import { dateUtils, appLocale } from 'shared';

const { RU } = appLocale.config.locales;

export const withI18n = (app: App) => {
  const locale = appLocale.lib.getAppLocale();

  const i18n = createI18n({
    locale,
    legacy: false, // https://vue-i18n.intlify.dev/guide/advanced/composition.html#basic-usage
    fallbackLocale: RU,
    warnHtmlMessage: false,
    pluralRules: {
      ru: appLocale.lib.getRussianPluralFormRules,
    },
    messages,
  });

  dateUtils.setLocale(locale); // Set dateUtils global locale

  app.use(i18n);
};
